import BaseWidget from 'components/BaseWidget/BaseWidget';
import BuoyConditionsWidget from './widgets/BuoyConditionsWidget/BuoyConditionsWidget';
import SurfAlertsWidget from './widgets/SurfAlertsWidget/SurfAlertsWidget';
import TideTableWidget from './widgets/TideTableWidget/TideTableWidget';
import WaveAndWindWidget from './widgets/WaveAndWindWidget/WaveAndWindWidget';

const MarineForecastWidget = ({
  widgetType = 'waveAndWind',
  dimensions,
  isLoading,
  containerSizePx,
}) => {
  return (
    <BaseWidget
      widgetType={widgetType}
      dimensions={dimensions}
      isLoading={isLoading}
      renderers={{
        waveAndWind: ({ layout, dimensions: widgetDimensions }) => (
          <WaveAndWindWidget
            layout={layout}
            dimensions={widgetDimensions}
            containerSizePx={containerSizePx}
          />
        ),
        surfAlerts: ({ layout, dimensions: widgetDimensions }) => (
          <SurfAlertsWidget
            layout={layout}
            dimensions={widgetDimensions}
            containerSizePx={containerSizePx}
          />
        ),
        buoyConditions: ({ layout, dimensions: widgetDimensions }) => (
          <BuoyConditionsWidget
            layout={layout}
            dimensions={widgetDimensions}
            containerSizePx={containerSizePx}
          />
        ),
        tideTable: ({ layout, dimensions: widgetDimensions }) => (
          <TideTableWidget
            layout={layout}
            dimensions={widgetDimensions}
            containerSizePx={containerSizePx}
          />
        ),
      }}
    />
  );
};

export default MarineForecastWidget;
